import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import PropertyEditPage from '../components/PropertyEditPage'
import {
  actionCreators,
  selectProperty,
} from '@app/components/PropertyEdit/modules/propertyEdit'
import { Property } from '@app/models/Property'

type IComponentState = ICurrentUserState & {
  property: Property
}

export default withRouter(
  connect(
    createStructuredSelector<ApplicationState, IComponentState>({
      user: selectCurrentUser(),
      property: selectProperty(),
    }),
    actionCreators,
  )(PropertyEditPage),
)
